import { getAllActionsAPI } from "../sevices/actionsService";

export const getAllActions =
  (token, filter = {}) =>
  async (dispatch) => {
    await dispatch(getAllActionsAPI(token, filter));
  };
